import { render, staticRenderFns } from "./UsedMaterialsNav.vue?vue&type=template&id=1b9b37b2&"
import script from "./UsedMaterialsNav.vue?vue&type=script&lang=js&"
export * from "./UsedMaterialsNav.vue?vue&type=script&lang=js&"
import style0 from "./UsedMaterialsNav.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports